import React, { useMemo } from 'react';
import { Link } from 'react-router';

import { getLoginURL } from '../../../utils/Auth';
import { resetAuthorizedUserState } from '../../../utils/Auth/handleDispatchToLogout';
import './Logout.css';

function Logout({ testId, text, className = '' }) {
  const loginURL = useMemo(() => getLoginURL(true), []);

  return (
    <Link
      data-testid={testId}
      className={'logout-link ' + className}
      style={{
        color: '#FFF',
      }}
      to={loginURL}
      onClick={resetAuthorizedUserState}
    >
      {text}
    </Link>
  );
}

export default Logout;
